export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0049_MR1_6241.e31129a9.jpg";